// app.js

import $ from 'jquery';
import 'what-input';
import 'imagesloaded';
import 'slick-carousel';
import 'jquery-match-height';

import Util from './module/Util';
const util = new Util();

import anime from 'animejs';

import Menu from './module/Menu';
new Menu;

import Accordion from './module/Accordion';
$('.js-accordion').each(function(){
  new Accordion( $(this) );
});

import iziModal from "izimodal/js/iziModal";
$.fn.iziModal = iziModal;

import Grid from './module/Grid';

// "Area": [ pc-l, pc-s, tab, sp ]
let gridsIndex = 0;
let gridIsAnime = window.devicePixelRatio > 1 ? false : true;
let grids = {
  "AreaMain": {
    "color": "rgba(255,255,255,0.25)",
    "rows": [3, 4, 6, 7]
  },
  "AreaComment": {
    "color": "#ece6e2",
    "rows": [2, 4, 7, 14]
  },
  "AreaAbout": {
    "color": "#fef1df",
    "rows": [4, 5, 6, 15]
  },
  "AreaSolutions": {
    "color": "rgba(255,255,255,0.2)",
    "rows": [13, 14, 33, 39]
  },
  "AreaPoint": {
    "color": "#fef1df",
    "rows": [3, 4, 13, 13]
  },
  "AreaFlow": {
    "color": "#ece6e2",
    "rows": [10, 18, 40, 50]
  },
  "AreaContact": {
    "color": "rgba(255,255,255,0.08)",
    "rows": [2, 3, 6, 9]
  },
  "AreaVoice": {
    "color": "#fef1df",
    "rows": [6, 7, 15, 24]
  },
  "AreaCompany": {
    "color": "#ece6e2",
    "rows": [5, 5, 8, 14]
  },
  "AreaFaq": {
    "color": "#fef1df",
    "rows": [4, 5, 6, 9]
  },
  "AreaContact2": {
    "color": "rgba(255,255,255,0.08)",
    "rows": [2, 3, 6, 9]
  },
  "Footer": {
    "color": "#fef1df",
    "rows": [1, 1, 1, 4]
  },
}

$(window).on('load', function(){
  Object.keys(grids).forEach(function(key){
    if( util.is._bp80 ){
      gridsIndex = 1;
    }
    if( util.is._bp60 ){
      gridsIndex = 2;
    }
    if( util.is._bp40 ){
      gridsIndex = 3;
    }

    let gridInstance = new Grid(key, grids[key]["rows"][gridsIndex], grids[key]["color"]);

    if( gridIsAnime ){
      grids[key]['instance'] = gridInstance;
      grids[key]['flg'] = false;
      grids['AreaMain']['instance'].anime();
      grids['AreaMain']['flg'] = true;
    }
    else {
      gridInstance.draw();
    }
  });

  $(window).on('scroll', function(){
    if( gridIsAnime ){
      Object.keys(grids).forEach(function(key){
        if( !grids[key]["flg"] ){
          let $elem = $('#'+key);
          let offset = $elem.offset().top;
          let ins = grids[key]["instance"];
    
          if( $(window).scrollTop() > offset - window.innerHeight/2 ){
            ins.anime();
            grids[key]["flg"] = true;
          }
        }
      });
    }
  });

});


$(function(){

  //
  anime({
    'targets': 'body',
    'opacity': 1,
    'duration': 1000,
    'easing': 'easeInOutQuad',
    'complete': function(anim){
      $('.AreaMainImageSlider').slick({
        fade: true,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        speed: 1200
      });
    }
  });


  // common
  $('html').css({
    '--scrollbar-width': (window.innerWidth - document.body.clientWidth) + 'px'
  });


  // 
  $('#ModalMovie').iziModal({
    width: "960px",
    overlayColor: "rgba(51, 51, 51, .95)",
    onOpened: function(){
      $('.ModalClose').fadeIn();
    },
    onClosing: function(){
      $('.ModalClose').fadeOut();
    }
  });

  $('#ModalPrivacyPolicy').iziModal({
    width: "960px",
    top: 104,
    bottom: 104,
    overlayColor: "rgba(51, 51, 51, .95)",
    onOpened: function(){
      $('.ModalClose').fadeIn();
    },
    onClosing: function(){
      $('.ModalClose').fadeOut();
    }
  })

  $(document).on('click', '.js-open-movie', function (e) {
    e.preventDefault();
    $('#ModalMovie').iziModal('open');
  });

  $(document).on('click', '.js-open-privacypolicy', function (e) {
    e.preventDefault();
    $('#ModalPrivacyPolicy').iziModal('open');
  });


  //
  $('a').each(function(){
    $(this).on({
      'touchstart': function(){
        $(this).addClass('hover');
      },
      'touchend': function(){
        $(this).removeClass('hover');
      }
    })
  });


  //
  $(window).on('scroll', function(){
    if( $(window).scrollTop() > window.innerHeight ){
      if( !$('body').hasClass('top--scrolled') ){
        $('body').addClass('top--scrolled');
        
        // PCのときはスクロールに合わせて動くけど、
        // SPのときはデフォルトは閉じたまま
        if( util.is.bp60 ){
          $('#FloatNav').addClass('rollup');
        }

      }
    }
    else {
      $('body').removeClass('top--scrolled');

      if( util.is.bp60 ){
        if( !$('#FloatNav').hasClass('clicked-close') ){
          $('#FloatNav').removeClass('rollup');
        }
      }
    }
  });

  if( util.is.bp60 ){
    $('#FloatNav').on({
      'mouseenter': function(){
        if( $(this).hasClass('rollup') ){
          $(this).removeClass('rollup');
        }
      },
      'mouseleave': function(){
        if( !$(this).hasClass('rollup') && $('body').hasClass('top--scrolled') ){
          $(this).addClass('rollup');
        }
      }
    });
  } // util.is.bp60

  if( util.is._bp60 ){
    $('#FloatNav').on({
      'click': function(){
        if( $(this).hasClass('showup') ){
          $(this).removeClass('showup');
        }
        else {
          $(this).addClass('showup');
        }
      }
    });
  } // util.is._bp60

  $('.FloatNavClose').on('click', function(){
    if( util.is.bp60 ){
      $('#FloatNav').addClass('rollup');
    }
    else {
      $('#FloatNav').addClass('showup');
    }

    $('#FloatNav').addClass('clicked-close');
  });

  window.matchMedia('(max-width:60em)').addListener(function(e){
    if( util.is.bp60 ){
      $('#FloatNav').removeClass('rollup');
    }
    else {
      $('#FloatNav').removeClass('showup');
    }
  });


  // 
  $('.PointListTitle').matchHeight(4);
  $('.CommentListText').matchHeight(4);


  // Solution
  let $solution = $('.SolutionsContent');
  let $solutioNav = $('.SolutionsContentNavList');
  let solutionOffsetBottom = $solution.offset().top + $solution.innerHeight() - $solutioNav.innerHeight();

  $(window).on('scroll', function(){
    let scrolltop = $(window).scrollTop();

    if( scrolltop > $solution.offset().top ){
      if( scrolltop > solutionOffsetBottom ){
        $solution.removeClass('fixed');
        $solution.addClass('absolute');
      }
      else {
        $solution.removeClass('absolute');
        $solution.addClass('fixed');
      }
    } 
    else {
      $solution.removeClass('fixed');
    }
    
    $('.SolutionsContentBoxItem').each(function(){
      let $this = $(this);
      let offset = $this.offset().top;

      if( scrolltop >= offset - 1 ){
        let index = $this.index();
        $solutioNav.find('li').removeClass('current');
        $solutioNav.find('li').eq(index).addClass('current');
      }
    })
  });


  $(window).on('resize', _resize);
  function _resize(){
    $('html').css({
      '--scrollbar-width': (window.innerWidth - document.body.clientWidth) + 'px'
    });
  }


});


window.requestAnimationFrame = ( function(){
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function(callback){
      window.setTimeout(callback, 1000.0 / 60.0);
    };
})();

window.cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;